// extracted by mini-css-extract-plugin
export default {"root":"KaEeLN","bg":"uYj0Sg"};